module.exports = __webpack_public_path__ + "media/images/insektenschutz-7e30e6f54757e83e440145dad2ba6fbd.jpg";